<template>
  <div :class="['modal', { open, [className]: className }]">
    <div class="modal__header">
      <div class="modal__title">
        <div class="modal__title--text textOverflow">
          {{ title }}
        </div>
      </div>
      <button class="modal__close" @click="$emit('closeclick', $event)">
        <iconClose />
      </button>
    </div>
    <div class="modal__body">
      <div class="modal__content">
        <slot />
      </div>
      <div v-if="hasAction" class="modal__actions">
        <Button
          v-if="$listeners.secondaryaction"
          secondary
          class="modal__action secondary"
          :busy="secondaryBusy"
          @click="$emit('secondaryaction', $event)"
        >
          {{ secondaryLabel }}
        </Button>
        <Button
          v-if="$listeners.action"
          :busy="busy"
          class="modal__action primary"
          @click="$emit('action', $event)"
        >
          {{ label }}
        </Button>
      </div>
    </div>
  </div>
</template>

<script>
import iconClose from '@/assets/icon-close.svg';
import Button from '@/components/Button';

export default {
  name: 'ModalBase',

  components: { iconClose, Button },

  props: {
    open: { type: Boolean, default: false },
    title: { type: String, default: '' },
    label: { type: String, default: 'Confirmar' },
    secondaryLabel: { type: String, default: 'Cancelar' },
    busy: { type: Boolean, default: null },
    secondaryBusy: { type: Boolean, default: null },
    className: {
      type: String,
      default: null,
    },
  },

  computed: {
    hasAction() {
      const { action, secondaryaction } = this.$listeners;

      return Boolean(action || secondaryaction);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
